const enUs = {
  'en-US': 'English',
  'nl-NL': 'Dutch',
  'fr-FR': 'French',
  'de-DE': 'German',
  'es-ES': 'Spanish',
  'pt-PT': 'Portuguese',
  'it-IT': 'Italian',
  'zh-CN': 'Chinese (Simplified)',
  'zh-TW': 'Chinese (Traditional)',
  'ko-KR': 'Korean',
  'ja-JP': 'Japanese',
  usd: 'United States Dollar',
  aed: 'United Arab Emirates Dirham',
  ars: 'Argentine Peso',
  aud: 'Australian Dollar',
  bdt: 'Bangladeshi Taka',
  bhd: 'Bahraini Dinar',
  bmd: 'Bermudian Dollar',
  brl: 'Brazilian Real',
  cad: 'Canadian Dollar',
  chf: 'Swiss Franc',
  clp: 'Chilean Peso',
  cny: 'Chinese Yuan',
  czk: 'Czech Koruna',
  dkk: 'Danish Krone',
  eur: 'Euro',
  gbp: 'British Pound Sterling',
  hkd: 'Hong Kong Dollar',
  huf: 'Hungarian Forint',
  idr: 'Indonesian Rupiah',
  ils: 'Israeli Shekel',
  inr: 'Indian Rupee',
  jpy: 'Japanese Yen',
  krw: 'South Korean Won',
  kwd: 'Kuwaiti Dinar',
  lkr: 'Sri Lankan Rupee',
  mmk: 'Burmese Kyat',
  mxn: 'Mexican Peso',
  myr: 'Malaysian Ringgit',
  ngn: 'Nigerian Naira',
  nok: 'Norwegian Krone',
  nzd: 'New Zealand Dollar',
  php: 'Philippine Peso',
  pkr: 'Pakistani Rupee',
  pln: 'Polish Złoty',
  rub: 'Russian Ruble',
  sar: 'Saudi Riyal',
  sek: 'Swedish Krona',
  sgd: 'Singapore Dollar',
  thb: 'Thai Baht',
  try: 'Turkish Lira',
  twd: 'New Taiwan Dollar',
  uah: 'Ukrainian Hryvnia',
  vef: 'Venezuelan Bolívar',
  vnd: 'Vietnamese Đồng',
  zar: 'South African Rand',
  slideTagLine: 'Intuitive wallet for your assets on the Internet Computer',
  signInWithIdentityProvider: 'Sign in with {{identityProvider}}',
  createNewWallet: 'Create a new wallet',
  createWalletWarning:
    "Write your mnemonic phrase on paper and store it securely. It won't be shown again and can't be retrieved later. Be cautious as anyone with access to the phrase can withdraw funds from your account.",
  createWalletAcknowledge:
    "I have written down the mnemonic phrase and understand that it can't be recovered",
  cancel: 'Cancel',
  create: 'Create',
  importExistingWallet: 'Import an existing wallet',
  importWalletInfo:
    'Mnemonic phrases, following the BIP39 standard and containing 12 or more words, are compatible',
  import: 'Import',
  token_one: 'Token',
  token_other: 'Tokens',
  nft_one: 'NFT',
  nft_other: 'NFTs',
  addToken: 'Add token',
  removeToken: 'Remove token',
  receive: 'Receive',
  received: 'Received',
  send: 'Send',
  sent: 'Sent',
  sentToSelf: 'Sent to self',
  account_one: 'Account',
  account_other: 'Accounts',
  createAccount: 'Create account',
  editAccount: 'Edit account',
  removeAccount: 'Remove account',
  copyAddress: 'Copy address',
  app_one: 'App',
  app_other: 'Apps',
  contact_one: 'Contact',
  contact_other: 'Contacts',
  setting_one: 'Setting',
  setting_other: 'Settings',
  lock: 'Lock',
  signOff: 'Sign off',
  interface: 'Interface',
  general: 'General',
  language: 'Language',
  theme: 'Theme',
  appTheme: 'App theme',
  red: 'Red',
  pink: 'Pink',
  purple: 'Purple',
  deepPurple: 'Deep purple',
  indigo: 'Indigo',
  blue: 'Blue',
  lightBlue: 'Light blue',
  cyan: 'Cyan',
  teal: 'Teal',
  green: 'Green',
  lightGreen: 'Light green',
  lime: 'Lime',
  yellow: 'Yellow',
  amber: 'Amber',
  orange: 'Orange',
  deepOrange: 'Deep orange',
  darkMode: 'Dark mode',
  followSystem: 'Follow system',
  off: 'Off',
  on: 'On',
  pureBlack: 'Pure black',
  interfaceSettingsList:
    '$t(language), $t(appTheme, lowercase), $t(darkMode, lowercase)',
  security: 'Security',
  transactionSigning: 'Transaction signing',
  secureSigning: 'Secure signing',
  password: 'Password',
  passwordRecommendations:
    'At least 12 characters of uppercase letters, lowercase letters, numbers, and symbols is recommended',
  biometrics: 'Biometrics',
  createWebAuthnToSign:
    'Follow browser instructions to create a WebAuthn identity to sign transactions with biometrics',
  incorrectIdentityProviderTryAgainToContinue:
    'Incorrect {{identityProvider}}, try again to continue',
  signInWithIdentityProviderToContinue:
    'Sign in with {{identityProvider}} to continue',
  retry: 'Retry',
  signIn: 'Sign in',
  incorrectMnemonicTryAgainToContinue:
    'Incorrect mnemonic phrase, try again to continue',
  enterMnemonicToContinue: 'Enter mnemonic phrase to continue',
  ok: 'OK',
  continue: 'Continue',
  lockWallet: 'Lock wallet',
  lockMethod: 'Lock method',
  none: 'None',
  lockWithWebAuthn:
    'Follow browser instructions to create WebAuthn identity to lock wallet with biometrics',
  autoLock: 'Auto lock',
  always: 'Always',
  browserSession: 'Browser session',
  securitySettingsList: '$t(secureSigning), $t(lockMethod, lowercase)',
  developer: 'Developer',
  lockedWallet: 'Locked wallet',
  unlockWithPassword: 'Enter password to unlock',
  unlockWithWebAuthn: 'Follow browser instructions to unlock with biometrics',
  unlock: 'Unlock',
  view: 'View',
  currency: 'Currency',
  add: 'Add',
  canisterId: 'Canister ID',
  tokenAlreadyAdded: 'Token has already been added',
  tokenNotSupported: 'Token is not supported',
  tokenHelpText: 'e.g. qddrf-jaaaa-aaaak-aapiq-cai',
  addContact: 'Add contact',
  signWithPassword: 'Enter password to sign',
  signWithWebAuthn: 'Follow browser instructions to sign with biometrics',
  sign: 'Sign',
  myAccounts: 'My accounts',
  balance: 'Balance',
  insufficientBalance: 'Insufficient balance',
  fee: 'Fee',
  to: 'To',
  confirm: 'Confirm',
  editContact: 'Edit Contact',
  username: 'Username',
  accountId: 'Account ID',
  memo: 'Memo',
  principalId: 'Principal ID',
  accountHash: 'Account #',
  accountIdDesc: 'Account identifier in ICRC-1 textual format',
  principalIdDesc: 'The unique identifier that all accounts are derived from',
  accountHashDesc: 'Account hash in ICP ledger format',
  edit: 'Edit',
  delete: 'Delete',
  notAvailable: 'Not available',
  transactionHistoryNotAvailable:
    'Transaction history is currently not available',
  collectionEmpty: 'Collection empty',
  noNftInCollection: 'No NFTs yet in this collection',
  attributes: 'Attributes',
} as const;

export default enUs;
